<template>
    <!-- Meta Tags -->
    <Head title="Contacto" />

    <section
        class="bg-contact bg-cover bg-center w-full min-h-screenheaderfooter flex justify-center items-center"
        id="main-content"
    >
        <div class="container py-8">
            <div class="w-full max-w-lg mx-auto">
                <h1 class="mb-4 md:mb-8 uppercase">Contacto</h1>
                <form @submit.prevent="handleForm">
                    <div class="w-full">
                        <div class="w-full flex flex-col justify-center items-center space-y-2">
                            <div class="w-full flex flex-col justify-start items-start">
                                <label class="font-bold mb-1" for="name">Nombre: (Requerido)</label>
                                <input
                                    id="name"
                                    v-model="form.name"
                                    class="w-full bg-white text-blue font-bold h-10 px-4 rounded-lg"
                                    type="text"
                                    placeholder="Luis Hernández"
                                    required
                                />
                                <div v-if="errors.name" class="text-red w-full py-1 my-1">{{ errors.name }}</div>
                            </div>
                            <div class="w-full flex flex-col justify-start items-start">
                                <label class="font-bold mb-1" for="email">E-mail: (Requerido)</label>
                                <input
                                    placeholder="correo@dominio.com"
                                    id="email"
                                    v-model="form.email"
                                    class="w-full bg-white text-blue font-bold h-10 px-4 rounded-lg"
                                    type="email"
                                    required
                                />
                                <div v-if="errors.email" class="text-red w-full py-1 my-1">{{ errors.email }}</div>
                            </div>
                            <div class="w-full flex flex-col justify-start items-start">
                                <label class="font-bold mb-1" for="subject">Asunto: (Requerido)</label>
                                <input
                                    placeholder="Solicitud de información"
                                    id="subject"
                                    v-model="form.subject"
                                    class="w-full bg-white text-blue font-bold h-10 px-4 rounded-lg"
                                    type="text"
                                    required
                                />
                                <div v-if="errors.subject" class="text-red w-full py-1 my-1">{{ errors.subject }}</div>
                            </div>
                            <div class="w-full flex flex-col justify-start items-start">
                                <label class="font-bold mb-1" for="message">Mensaje: (Requerido)</label>
                                <textarea
                                    id="message"
                                    v-model="form.message"
                                    class="w-full bg-white text-blue font-bold h-40 p-4 rounded-2xl"
                                    required
                                ></textarea>
                                <div v-if="errors.message" class="text-red w-full py-1 my-1">{{ errors.message }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="g-recaptcha mt-4" data-sitekey=""></div> 

                    <p class="text-red rounded-xl w-full py-2 text-center my-2" v-if="$page.props.flash.message">
                        {{ $page.props.flash.message }}
                    </p>

                    <div class="flex justify-center mt-6">
                        <button
                            type="submit"
                            class="block font-bold bg-yellow text-blue rounded-lg w-52 h-10 hover:bg-opacity-80"
                            :disabled="form.processing"
                        >
                            Enviar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "Contact",
    props: ["errors"],
    data() {
        return {
            form: this.$inertia.form({
                name: null,
                email: null,
                subject: null,
                message: null,
            }),
        };
    },
    methods: {
        handleForm() {
            dataLayer.push({
                event: "form_contacto",
                user_id: this.form.email,
            });
            this.form.post(this.$page.props.baseUrl + "/contacto");
        },
    },
};
</script>
<style></style>
